import { FIELD_SCROLL_GAP_PX } from './config'

/** Элемент, ради которого система показывает экранную клавиатуру. */
export function isTextField(element: Element | null): element is HTMLElement {
  if (element instanceof HTMLTextAreaElement) return true
  if (element instanceof HTMLInputElement) {
    return !['button', 'checkbox', 'file', 'radio', 'range', 'reset', 'submit'].includes(
      element.type,
    )
  }
  return element instanceof HTMLElement && element.isContentEditable
}

/**
 * Подскроллить область шторки так, чтобы поле оказалось над клавиатурой.
 *
 * Считаем и двигаем сами, а не `scrollIntoView()`: штатный метод скроллит ВСЕХ предков вплоть
 * до окна, и на iOS это тот самый сдвиг всей страницы, из-за которого шторка вместе с фоном
 * уезжает вверх. Здесь двигается ровно один контейнер и ровно на недостающую величину.
 */
export function scrollFieldIntoView(container: HTMLElement, field: HTMLElement): void {
  const containerBox = container.getBoundingClientRect()
  const fieldBox = field.getBoundingClientRect()

  const below = fieldBox.bottom + FIELD_SCROLL_GAP_PX - containerBox.bottom
  if (below > 0) {
    container.scrollTop += below
    return
  }

  const above = containerBox.top - (fieldBox.top - FIELD_SCROLL_GAP_PX)
  if (above > 0) container.scrollTop -= above
}
